export default __webpack_public_path__ + "static/media/jonexpress.67ecd450.png";